<template>
  <v-container style="height: 100%; width: 100%" fluid class="login-container" no-gutters>
    <v-container fluid fill-height>
      <v-row no-gutters class="mt-2 mb-4 row align-center">
        <v-col sm="12" class="login-modal">
          <v-card elevation="2" height="100%" width="500" style="background-color: rgba(255, 255, 255, 0.9)">
            <v-toolbar :style="{ backgroundColor: computedBackgroundColor }">
              <v-toolbar-title style="color: white">Verification Code</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              We sent you an email. Verification code has been sent to your registered email address. Please enter the
              code that you have received.
            </v-card-text>
            <v-card-text>
              <form ref="form" @submit.prevent="verifyOtp">
                <v-text-field v-model="otp" name="otp" id="change-number-appearance" label="Verification Code"
                  type="number" @wheel.prevent="handleWheelEvent" placeholder="Enter Verification Code"
                  required></v-text-field>
                <v-row>
                  <v-col class="align-center">
                    <v-btn Contained class="mt-4" color="primary" value="log in" type="submit" style="width: 55%"
                      :style="{ backgroundColor: computedBackgroundColor }">Verify</v-btn>
                    <v-btn Contained class="mt-4" @click.stop="refreshTheCurrentPage()" color="default" value="cancel"
                      type="button" style="width: 55%">Cancel</v-btn>
                  </v-col>
                </v-row>
              </form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { Auth } from "aws-amplify";
import { mapGetters, mapState } from "vuex";

export default {
  name: "contact-us",
  components: {},
  data() {
    return {
      otp: "",
      userDeails: "",
      strText: "",
      strTitle: "",
      hasError: false,
    };
  },
  mounted() {
    // this.getAttributes();
    // eslint-disable-next-line
    this.userDeails = this.user;
  },
  methods: {
    async verifyOtp() {
      try {
        // console.log(this.userDeails);
        // console.log(this.otp);
        const loggedUser = await Auth.sendCustomChallengeAnswer(
          this.userDeails, // Return object from Auth.signIn()
          this.otp // Confirmation code
          // 'SMS_MFA' // MFA Type e.g. SMS_MFA, SOFTWARE_TOKEN_MFA
        );
        if (loggedUser?.signInUserSession) {
          this.$store.commit("setAuthentication", true);
          this.$router.push("/Home");
        } else {
          this.strText = "Invalid OTP";
          this.strTitle = "OTP Error";
          this.showModal(this.strText, this.strTitle);
          this.hasError = true;
        }
      } catch (error) {
        console.error("error at 76 line ", error?.message);
        const errorMessage = [
          "Invalid session for the user.",
          "Incorrect username or password.",
          "Invalid code or auth state for the user.",
        ];

        if (
          error.message ===
          "Temporary password has expired and must be reset by an administrator."
        ) {
          // this.openForgotPW()
          await Auth.forgotPassword(this.username);
        } else if (errorMessage.includes(error.message)) {
          this.strText =
            "You have reached the maximum attempts. Please go to the login page and try again.";
          this.strTitle = "OTP Error";
          this.showModal(this.strText, this.strTitle);
          this.hasError = true;
          // this.computedBackgroundColor;
          // Handle other login errors
        }
      }
    },
    showModal(strText, strTitle) {
      this.$store.commit("toggleDialog", {
        show: true,
        text: strText,
        titleText: strTitle,
      });
    },
    refreshTheCurrentPage() {
      this.$router.go()
    },
    handleWheelEvent(event) {
      event.preventDefault();
    }
  },
  computed: {
    ...mapState(["user"]),
    ...mapGetters(["getUser"]),
    user() {
      return this.getUser;
    },
    computedBackgroundColor() {
      // Replace this logic with your desired condition to set the background color dynamically
      if (this.hasError) {
        return "red"; // Set the background color to red when there's an error
      }
      return "rgba(0, 0, 0, 0.8)"; // Default background color when no error
    },
  },
};
</script>
<style>
.login-container {
  background-image: url("~@/assets/background.png");
  /* Replace with the path to your PNG image */
  background-size: cover;
  background-position: center;
  min-height: 100vh;
}

.login-modal {
  display: flex;
  justify-content: center;
  /* Horizontally center-align */
  align-items: center;
  /* Vertically center-align */
}

.login-window {
  background-color: navy;
}

.custom-app-bar {
  background-color: white;
}

.align-left {
  text-align: left;
}

.align-right {
  text-align: right;
}

.align-center {
  align-items: center;
}

.small-font {
  font-size: 10px;
}

.row.align-center {
  align-items: center;
}

.v-slider__thumb {
  cursor: pointer;
}

.wrongPassword {
  background-color: rgb(255, 0, 0);
}

/* Added css for remove number arrows */

#change-number-appearance::-webkit-outer-spin-button,
#change-number-appearance::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

#change-number-appearance {
  -moz-appearance: textfield;
  /* Firefox */
}
</style>
